import { Trans } from '@lingui/react/macro';
import dayjs from 'dayjs';

import { type WebTrafficCompanySummaryDataType } from '@/api/activity';
import LetteredAvatar from '@/components/LetteredAvatar';
import { Link, Text } from '@/components/typography';
import { USDateViewFormat } from '@/constants/formats';
import { ROUTES } from '@/router';
import { COLOR_PRIMARY } from '@/styles/palette';

import StatField from './StatField';
import StatFieldItem from './StatFieldItem';

type CompanyVisitChartCaptionProps = {
  data?: WebTrafficCompanySummaryDataType;
};

const CompanyVisitChartCaption = ({ data }: CompanyVisitChartCaptionProps) => {
  if (!data) {
    return null;
  }

  return (
    <div className="flex flex-1 flex-col gap-4 overflow-hidden p-2">
      {data.metrics.lastActivityDate && (
        <StatField label={<Trans>Last Visit</Trans>}>
          <Text variant="caption1">
            {dayjs(data.metrics.lastActivityDate).format(USDateViewFormat)}
          </Text>
        </StatField>
      )}
      {data.audiences && data.audiences.length > 0 && (
        <StatField label={<Trans>Audience Membership</Trans>}>
          {data.audiences?.map((audience) => (
            <StatFieldItem key={audience.id} tooltip={audience.name}>
              <div className="flex items-center gap-1">
                {audience.isTAM && (
                  <LetteredAvatar name="T" color={COLOR_PRIMARY} shape="circle" size="xsmall" />
                )}
                <Link variant="caption1" to={ROUTES.audienceById(audience.id)}>
                  {audience.name}
                </Link>
              </div>
            </StatFieldItem>
          ))}
        </StatField>
      )}
    </div>
  );
};

export default CompanyVisitChartCaption;
